import useAuth from '@/hooks/useAuth'
import SEO from '@/components/seo'
import Support from '@/components/support'
import ForProCategories from '@/views/for/pro/categories'
import ForProClient from '@/views/for/pro/client'
import ForProFAQ from '@/views/for/pro/faq'
import Hero from '@/views/for/pro/hero'
import ForProProcess from '@/views/for/pro/process'
import RegisterPro from '@/views/for/pro/register-pro'
import ForProSystem from '@/views/for/pro/system'

const ForProfessionalPage = () => {
  const { currentUser } = useAuth()

  return (
    <>
      <SEO
        title="依頼を受ける際のご利用の流れ"
        url="for/pro"
        description="ONLIVE Studioなら、あなたのアーティスト活動を更にステージアップさせてくれるクリエイターがあなたの悩みや相談に応えてくれます。"
      />
      <section className="mb-20">
        <Hero />
      </section>
      <section className="mb-32">
        <ForProClient />
      </section>
      <section className="mb-32">
        <ForProProcess />
      </section>
      <section className="mb-32">
        <ForProCategories />
      </section>
      <section className="mb-32">
        <ForProSystem />
      </section>
      <section className="mb-32">
        <ForProFAQ />
      </section>
      {!currentUser?.isProfessional && (
        <section className="mb-32">
          <RegisterPro />
        </section>
      )}
      <section className="mb-32">
        <Support />
      </section>
    </>
  )
}

export default ForProfessionalPage
